import { useQuery } from '@apollo/client';
import {
  LmsCurriculumDocument,
  LmsCurriculumQuery,
} from 'src/graphql/generated/graphql';

export const useLmsCurriculum = ({ id }: { id?: string }) => {
  const { data, loading } = useQuery<LmsCurriculumQuery>(
    LmsCurriculumDocument,
    {
      variables: {
        id: id,
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only',
      skip: !id,
    },
  );

  return {
    entity: data?.lmsCurriculum,
    loading,
  };
};
